var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCovid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5469 12.9015C76.7807 26.1353 83.8601 55.7602 70.6263 68.994C57.3925 82.2279 28.3119 78.9603 15.0781 65.7265C1.84422 52.4927 18.8978 31.7522 32.1316 18.5184C45.3655 5.28454 50.3131 -0.332331 63.5469 12.9015Z",
    fill: "#F7F8F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8274 43.3771C67.9386 56.0738 48.6508 62.5743 38.8968 58.7859C30.1935 54.4711 27.5525 41.904 34.2703 33.8891C40.9881 25.8742 54.1884 27.5061 61.8274 43.3771Z",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5754 38.1037C41.1878 37.0494 43.2164 35.3533 44.4042 34.637C44.9489 34.2772 46.6218 35.8068 46.2735 37.2346C45.9253 38.6623 44.3099 39.4216 42.5754 38.1037Z",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7624 44.8165C54.1477 43.5254 55.393 42.5977 56.0924 42.2953C57.0428 42.7966 58.6268 43.6322 58.2785 45.06C57.9303 46.4877 55.5308 46.4305 54.7624 44.8165Z",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3437 54.4591C51.1161 56.0113 48.9561 56.2545 47.7796 56.1821C47.2302 56.1731 46.3812 54.1011 47.1138 53.1772C47.8465 52.2534 49.3782 52.5187 50.3437 54.4591Z",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3437 45.4591C49.1161 47.0113 46.9561 47.2545 45.7796 47.1821C45.2302 47.1731 44.3812 45.1011 45.1138 44.1772C45.8465 43.2534 47.3782 43.5187 48.3437 45.4591Z",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2329 44.9511C37.8252 46.2527 36.5641 47.1587 35.8595 47.449C34.9179 46.9313 33.3487 46.0685 33.7215 44.647C34.0944 43.2254 36.4925 43.3241 37.2329 44.9511Z",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2306 56.808C34.991 58.2473 34.4095 59.6009 32 61.5012M54.276 25.4262C54.0431 26.7448 53.3618 29.8058 52.5 31.5012M62.5 51.5012C64 52.308 63.5 51.5012 66.5 54.5012",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6959 39.7617C29.36 40.3485 27.9088 40.6022 24.9999 39.6247M67.3844 38.5381C66.1532 39.0644 63.2181 40.1686 61.3274 40.3745M45.4999 60C45.6451 61.697 47.3701 61.8476 46.4999 66",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5251 30.0023C38.349 29.1387 37.4037 28.0087 36.7958 25.0008M59.5 61.5009C58.4285 60.6978 56.6237 59.5352 55.5 58.0008M31 50.0009C29.6029 50.9751 31.0312 50.6783 27 52.0009",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovid);
export default __webpack_public_path__ + "static/media/covid.192122ff12d708c2e4543471cc6282d5.svg";
export { ForwardRef as ReactComponent };